import { v4 as uuid } from 'uuid';
import { Translation } from './types';

 // NEED TO CHANGE LABELS HERE WITH TRANSLATIONS IF THEY EXIST
 export const interviewTranslations = (translations, transIds, localeCode) => {
    let ids;
    let translationJSON = [];
    let translationObject: Translation;
    if(translations != null && transIds != null){
      translations.map((aInterview) => {
        ids = {};
        Object.keys(aInterview.translation_json).forEach(function(key) {
          ids[key] = {key: key, locale_code: aInterview.locale_code, translation: aInterview.translation_json[key]};
        });
      });
      if(ids){
        transIds.map((aId) => {
          if(aId.id == ids[aId.id]["key"] && localeCode == ids[aId.id]["locale_code"]){  
            if(ids[aId.id]["translation"]){
              translationObject = ids[aId.id];
              translationObject.id = aId.obj_id;
              translationObject.default = aId.default;
              translationJSON.push(translationObject);
            }
          }
        });
      }
    }
    return translationJSON;
  }

  export const extraTranslations = (translations, extra) => {
    //Swaps choices or next steps with the translated version if they are found.
    if(translations.length > 0 ){
      for(var i=0; i<translations.length; i++){
        for(var j=0; j<extra.length; j++){  
          if(translations[i].id == extra[j].id){
            extra[j].label = translations[i].translation;
            extra[j].default = translations[i].default;
          }
          else if(translations[i].default == extra[j].label){
            extra[j].label = translations[i].translation;
            extra[j].default = translations[i].default;
          }
        }
      }
    }
    else{
      for(var i=0; i<extra.length; i++){
        if(extra[i].default){
          extra[i].label = extra[i].default;
        }
      }
    }
    return extra;
  }

// Dropdown values to be populated
  export type Measurement = {
    id: string;
    label: string;
    type: string;
  }

  export type Rule = {
    id: number;
    measurement: Measurement;
    condition: string;
    measurementValue: any;
    shouldShowCondition: boolean;
  }

  export type Condition = {
    conditionType: string;
    statements: Array<Statement>;
  }

  export type Statement = {
    lhs: Measurement;
    operator: string;
    rhs: string;
    condition: Condition;
  }

  export type Step = {
    id: string;
    name: string;
    stepLabel: string;
    step_group_id: string;
  }
  
  // Rules tree node base class
  export class NodeType {
    id: string;
    children: Array<any>;
    parent: NodeType;
    constructor(id) {
      this.id = id;
      this.children = [];
      this.parent = null;
    }

    validate(): boolean {
      console.log("Validating generic node .... " + true);
      return true;
    }

    addChild(node: NodeType) {
      if (node) {
        node.parent = this;
        if (this.children.length > 0 ) {
          this.children.splice(this.children.length-1, 0, node);
        } else {
          this.children.push(node);
        }
      }
    }

    getNodeType() {
      return "";
    }

    getRuleObject(): string {
      return null;
    }
  }

  export class ConditionNode extends NodeType{
    condition: string;
    isComplemented: boolean;

    constructor(id, condition) {
      super(id);
      this.condition = condition;
      this.isComplemented = false;
    }

    validate(): boolean {
      let retVal = false;
      
      if (this.condition && this.condition.length > 0) {
        retVal = true;
      }
      console.log("Validating condition node .... " + retVal);
      return retVal;
    }

    getNodeType() {
      return "ConditionNode";
    }

    getRuleObject(): any {
      let ruleObject = null;

      if (this.validate()) {
      }

      return ruleObject;
    }
  }

  export class AddNode extends NodeType {
    addNodeType: string;

    constructor(id, addType) {
      super(id);
      this.addNodeType = addType;
    }

    getNodeType() {
      return "AddNode";
    }
  }

  export class StatementNode extends NodeType{
    lhs: string;
    operator: string;
    rhs: string;

    constructor(id, lhs, operator, rhs) {
      super(id);
      this.lhs = lhs;
      this.rhs = rhs;
      this.operator = operator;
    }

    getNodeType() {
      return "StatementNode";
    }

    validate(): boolean {
      let retVal = false;

      if (this.lhs && this.lhs.length > 0 &&
          this.operator && this.operator.length > 0 &&
          this.rhs && this.rhs.length > 0 ) {
            retVal = true;
      } 
      console.log("Validating statement node .... " + retVal);
      return retVal;
    }

    getRuleObject(): any {
      let ruleObject = null;

      if (this.validate()) {
        ruleObject = {
          fact: this.lhs,
          operator: this.operator,
          value: this.rhs
        }
      }

      return ruleObject;
    }
  }

  export const getNodeById = (ruleData: NodeType, id: string) => {
    let node = null;
    if (ruleData) {
      if (ruleData.id == id ) {
        node = ruleData;
      } else if (ruleData.children && ruleData.children.length > 0) {
        for (let child of ruleData.children) {
          if (child.id == id) {
            node = child;
            return node;
          }
          node = getNodeById(child, id);
        }
      }
    }

    return node;
  }

  // Get final json compatible for json-rules-engine
  export const getRulesOptions = (rulesData: NodeType) => {

    let rulesJsonObj = getRulesJson(rulesData);
    
    return rulesJsonObj;
  }

  // Traverse rules tree to form the json
  const getRulesJson = (ruleData: NodeType) => {
    let conditionObj = {};
    let statements = [];
    if (ruleData) {
      if (ruleData.getNodeType() === "ConditionNode" ) {
        conditionObj = {[(ruleData as ConditionNode).condition] : []};
      } 

      if (ruleData.children && ruleData.children.length > 0 ) {
        for (let child of ruleData.children) {
          if (child.getNodeType() === "StatementNode") {
            statements.push((child as StatementNode).getRuleObject());
          } else if (child.getNodeType() === "ConditionNode" ) {
            let subCondition = getRulesOptions(child);
            statements.push(subCondition);
          }
        }
        conditionObj[(ruleData as ConditionNode).condition] = statements;
      } 
    }
    return conditionObj;
  }

  var validationRes = true;

  export const resetValidationResult  = () => {
    validationRes = true;
  }

  export const validateRules = (rules: Array<NodeType>) => {
    let retVal = true;

    for (let aRule of rules) {
      if (aRule.children && aRule.children.length > 0 ) {
        retVal = validateRules(aRule.children);
      }
      retVal = aRule.validate();
      if (!retVal) {
        validationRes = false;
        break;
      }
    }

    return validationRes;
  }

  var interviewSteps = [];
  export default interviewSteps;

  //TODO: Only for testing UI
  export const exampleSteps = [
    {id: "0", name: "TextStep", stepLabel:  "Welcome step", step_group_id: "0" },
    {id: "1", name: "Question", stepLabel:  "Condition", step_group_id: "0" },
    {id: "2", name: "Sensor", stepLabel:  "BP", step_group_id: "0" },
    {id: "3", name: "Question", stepLabel:  "Excercise", step_group_id: "0" },
    {id: "4", name: "MultiAnswer", stepLabel:  "Diet", step_group_id: "0" },
    {id: "5", name: "Sensor", stepLabel:  "BG", step_group_id: "0" },
    {id: "6", name: "TextStep", stepLabel:  "Some information", step_group_id: "0" },
    {id: "7", name: "Sensor", stepLabel:  "BT", step_group_id: "0" },
    {id: "8", name: "Sensor", stepLabel:  "WT", step_group_id: "0" },
    {id: "9", name: "Sensor", stepLabel:  "SPO2", step_group_id: "0" },
  ];

